const BIG_IMAGE_WITH_TABS_BLOCK_DIGITIZE = {
  titlesList: [
    {
      id: 1,
      text: '',
      textMob: '',
      secondText: 'An Experienced Team & Better Process Equals',
      secondTextMob: 'An Experienced Team &\nBetter Process Equals',
      isTextReverse: false,
      isTextReverseMob: false,
      isTextColumn: false,
      isTextColumnMob: true,
      isLeft: true,
      isLeftMob: true,
      isRight: false,
      isRightMob: false,
      color: '#fff',
      colorMob: '#fff',
      isTextWithLine: true,
      isTextWithLineMob: true,
      isSecondTextWithLine: true,
      isSecondTextWithLineMob: true,
      firstTextLines: [],
      secondTextLines: [],
    },
    {
      id: 1,
      text: 'Unparalleled Quality.',
      textMob: 'Top Quality.',
      secondText: '',
      secondTextMob: '',
      isTextReverse: false,
      isTextReverseMob: false,
      isTextColumn: false,
      isTextColumnMob: false,
      isLeft: false,
      isLeftMob: true,
      isRight: true,
      isRightMob: false,
      color: '#fff',
      colorMob: '#fff',
      isTextWithLine: true,
      isTextWithLineMob: true,
      isSecondTextWithLine: true,
      isSecondTextWithLineMob: true,
      firstTextLines: [{
        id: 1,
        isLeftLine: true,
        isRightLine: false,
        isTopLine: false,
        isBottomLine: false,
        color: '#fff',
        isLineWithSquare: true,
        isLeftLineMob: false,
        isRightLineMob: true,
        isTopLineMob: false,
        isBottomLineMob: false,
        colorMob: '#fff',
        isLineWithSquareMob: true,
      }],
      secondTextLines: [],
    },
  ],
  tabs: [
    {
      key: 'TAPES',
      tabTitle: 'TAPES',
      tabTitleMobile: 'TAPES',
      classNameImage: 'second-block-image-wrapper',
      mediaData: '',
      classNameDescription: 'second-block-description',
      title: 'VHS, VHS-C, HI-8, Mini-DV, Betamax, & more.',
      description: 'Forever Studios is known nationwide for having one of the most advanced tape transfer services available to the public. \n\nNo other video transfer service has invested as much time, effort, or development into converting home movies to digital, and that\'s reflected in your digital videos being clearer, sharper, & higher resolution than any other home movie digitizing service in the USA.',
      classNameButton: 'second-block-button',
      buttonText: 'Digitize Tapes',
      buttonLink: '',
      buttonFunc: () => {},
      withPrice: true,
      price: 0,
      additionalDiscount: 0,
      perText: 'Per tape',
    },
    {
      key: 'PHOTOS',
      tabTitle: 'PHOTOS',
      tabTitleMob: 'Photo & Slides',
      classNameImage: 'second-block-image-wrapper',
      mediaData: '',
      classNameDescription: 'second-block-description',
      title: 'Loose photos, albums, slides, & negatives.',
      description: 'Old photos, 35mm slides & film negatives are quickly becoming endangered historical materials. Put the same professional digitizing services trusted by museums and historical societies to work for your family, and we guarantee you\'ll love the results. \n\nEvery photo, slide or negative you send us is delicately hand scanned by digitizing experts, using professional quality scanning equipment with special attention paid to cleanliness and clarity.',
      classNameButton: 'second-block-button',
      buttonText: 'Scan my photos',
      buttonLink: '',
      buttonFunc: () => {},
      withPrice: true,
      price: 0,
      additionalDiscount: 0,
      perText: 'Per photo',
    },
    {
      key: '8MM & 16MM FILM',
      tabTitle: '8MM & 16MM FILM',
      tabTitleMob: 'Movie Film',
      classNameImage: 'second-block-image-wrapper',
      mediaData: '',
      classNameDescription: 'second-block-description',
      title: 'Old 8mm, 16mm, and Super 8.',
      description: 'Historical archiving of your delicate 8mm film reels is a project that requires a well developed technical process, as well as trained staff of expert technicians. \nThankfully, Forever Studios has plenty of both, and our home movie digitizing service consistently scores a perfect 10 in customer reviews. This is achieved through bespoke projectors, modified specifically for premium clarity digitizing of old film reels, as well as complimentary reconditioning of your film.',
      classNameButton: 'second-block-button',
      buttonText: 'Transfer my Film',
      buttonLink: '',
      buttonFunc: () => {},
      withPrice: true,
      price: 0,
      additionalDiscount: 0,
      perText: 'Per reel',
    },
    {
      key: 'CDS & DVDS',
      tabTitle: 'CDS & DVDS',
      tabTitleMob: 'CD & DVD Transfer',
      classNameImage: 'second-block-image-wrapper',
      mediaData: '',
      classNameDescription: 'second-block-description',
      title: 'Audio & Photo CDs, all DVDs, & Mini DVD.',
      description: 'When it comes to Audio CDs and Video DVDs, there are no other truly convenient services out there to help transfer large amounts of discs to useful modern digital formats. \nFor this reason, Forever Studios offers an affordable solution that will help you archive and enjoy your disc based media. You can expect premium quality, and easily enjoyable digital files thanks to our professional grade optical disc drives and disc imaging software.',
      classNameButton: 'second-block-button',
      buttonText: 'Transfer my Discs',
      buttonLink: '',
      buttonFunc: () => {},
      withPrice: true,
      price: 0,
      additionalDiscount: 0,
      perText: 'Per disc',
    },
    {
      key: 'AUDIO',
      tabTitle: 'AUDIO',
      tabTitleMob: 'Audio Digitizing',
      classNameImage: 'second-block-image-wrapper',
      mediaData: '',
      classNameDescription: 'second-block-description',
      title: 'Cassettes, Vinyl LPs, Reel to Reel.',
      description: 'Digitizing of old analog audio formats such as audio cassette conversion and reel to reel audio tape transfer is a process that must be done with care. The gap in quality between our professional transfers and the average competitor can easily be the difference between re-capturing the magic of the original or not.\nOur process involves use of high-grade playback devices and live engineering of results by a Digitize Studio technician with specific audio capture skills.',
      classNameButton: 'second-block-button',
      buttonText: 'Transfer my Audio',
      buttonLink: '',
      buttonFunc: () => {},
      withPrice: true,
      price: 0,
      additionalDiscount: 0,
      perText: 'Per item',
    },
  ],
};

export default BIG_IMAGE_WITH_TABS_BLOCK_DIGITIZE;
